import Head from 'next/head';
import PropTypes from 'prop-types';

export default function SeoJsonLdChannel({ seoJsonSchema = '' }) {
	if (!seoJsonSchema) return null;

	return (
		<Head>
			<script
				type="application/ld+json"
				// eslint-disable-next-line react/no-danger
				dangerouslySetInnerHTML={{
					__html: `${seoJsonSchema}`,
				}}
			/>
		</Head>
	);
}

SeoJsonLdChannel.propTypes = {
	seoJsonSchema: PropTypes.string,
};
